import { render } from "./ValidationErrors.vue?vue&type=template&id=3bef58da&scoped=true"
import script from "./ValidationErrors.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ValidationErrors.vue?vue&type=script&charset=utf-8&lang=js"

import "./ValidationErrors.vue?vue&type=style&index=0&id=3bef58da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bef58da"]])

export default __exports__